import { IdentifierType, ProductInfoField } from 'core/api/types'
import Base from 'core/pages/SimpleItemList/SimpleItemListReading'
import { getNfcReadConfiguration, isNfcAuthEnabled } from 'stylewhere/shared/nfcAuthentication'
import { OperationReadingProps, OperationReadingState, RfidReader } from 'core/shared'
import { __, T } from 'core/shared/i18n'
import { showToastError, sleep } from 'core/shared/utils'

interface State extends OperationReadingState {
  confirming: boolean
  barcodeItemReading: boolean
  removeModeEnabled: boolean
}

export default class SimpleItemListReading extends Base<OperationReadingProps<State>, State> {
  overrideProductInfoFields: () => ProductInfoField[] | undefined = () => {
    return []
  }

  getHideIdentifierZones: () => boolean = () => {
    return true
  }

  getHideIdentifierCodeByType = (): IdentifierType[] | undefined => {
    return ['NFC_TAG', 'UHF_TAG']
  }

  /** LV-only: reject readings with more than one NFC tag, then run core NFC auth decode. */
  decodeFunctionWithSingleNfcLimit = async (
    tags: string[],
    types: (IdentifierType | undefined)[],
    antennaIds?: string[]
  ) => {
    const tagsMap: { [code: string]: IdentifierType } = tags.reduce((acc, tag, index) => {
      acc[tag] = types[index]
      return acc
    }, {})

    if (Object.values(tagsMap).filter((type) => type === 'NFC_TAG').length > 1) {
      await sleep(1000)
      showToastError(new Error('Only one NFC tag is allowed'), __(T.error.error), this.isModal)
      await this.stopAntenna()
      return {}
    }

    return this.decodeFunction(tags, types, antennaIds)
  }

  setRfidReaderDecode = () => {
    if (isNfcAuthEnabled(this.operation)) {
      RfidReader.setDecodeFunction(this.decodeFunctionWithSingleNfcLimit)
    }
    RfidReader.setNfcReadConfiguration(getNfcReadConfiguration(this.operation))
    RfidReader.setOnDecodedItemCallback(this.onDecodedItemCallback, this.getDecodeRequest())
  }

  getDecodeFunction = () => {
    return isNfcAuthEnabled(this.operation) ? this.decodeFunctionWithSingleNfcLimit : undefined
  }
}
